import React, { useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { T } from 'shared/helper/translate';
import SubscriptionErrorMessage from './SubscriptionErrorMessage';
var getMessageContent = function getMessageContent(message) {
  if (message.customRender === 'subscriptionErrorWithLink') {
    return /*#__PURE__*/React.createElement(SubscriptionErrorMessage, {
      message: message,
      onLinkClick: message.onLinkClick
    });
  }
  return /*#__PURE__*/React.createElement(T, {
    source: message.message,
    params: message.params || {}
  });
};
var messageProperties = function messageProperties(message, onClose) {
  return {
    autoClose: 8000,
    position: 'bottom-center',
    onClose: onClose,
    type: message.type,
    render: getMessageContent(message)
  };
};
var EphemeralFlashMessage = function EphemeralFlashMessage(_ref) {
  var dismissMessage = _ref.dismissMessage,
    message = _ref.message;
  var toastId = useRef(null);
  useEffect(function () {
    toastId.current = toast(getMessageContent(message), messageProperties(message, dismissMessage));
  }, []);
  useEffect(function () {
    if (toastId.current) {
      toast.update(toastId.current, messageProperties(message, dismissMessage));
    }
  }, [message.message]);
  return /*#__PURE__*/React.createElement(ToastContainer, null);
};
export default EphemeralFlashMessage;